var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1E54D5","fillOpacity":".223","fillRule":"nonzero","d":"M12.556 0H5.333C2.4 0 0 2.497 0 5.548v14.796c0 3.051 2.4 5.548 5.333 5.548h4.3c.511 0 .923.45.89.994a14.374 14.374 0 0 1-3.479 8.565C6.522 36.052 6.934 37 7.7 37h4.433a.852.852 0 0 0 .7-.358C13.656 35.532 16 31.833 16 25.788V3.595C16 1.537 14.522 0 12.556 0zm21 0h-7.223C23.4 0 21 2.497 21 5.548v14.796c0 3.051 2.4 5.548 5.333 5.548h4.3c.511 0 .923.45.89.994a14.374 14.374 0 0 1-3.479 8.565c-.522.601-.11 1.549.656 1.549h4.433a.852.852 0 0 0 .7-.358C34.656 35.532 37 31.833 37 25.788V3.595C37 1.537 35.522 0 33.556 0z"}));
}

Quote.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37"};

module.exports = Quote;

Quote.default = Quote;
